import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChanges,
  ViewChild,
  WritableSignal
} from '@angular/core';
import { SohoSearchFieldComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-facade-module-header',
  standalone: false,
  templateUrl: './lm-facade-module-header.component.html',
  styleUrl: './lm-facade-module-header.component.scss',
})
export class LMFacadeModuleHeaderComponent implements OnChanges {

  @Input() showWelcome = false;
  @Input() moduleFacades: Array<LMModuleFacade> | undefined;
  @Input() state!: LMFacadeExplorerState;

  @Output() search: EventEmitter<LMFacadeSearchEvent> = new EventEmitter<LMFacadeSearchEvent>();

  searchValue = signal('');
  searchPlaceholder = signal(Soho.Locale.translate('Search'));
  searchCategories:  WritableSignal<SohoSearchFieldCategoryType[]> = signal( []);

  @ViewChild(SohoSearchFieldComponent) searchField: SohoSearchFieldComponent | undefined;

  constructor(  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.moduleFacades) {
      this.buildSearchFieldCategories();
    }
  }

  private buildSearchFieldCategories(): void {
    if (this.moduleFacades) {
      const updatedSearchCategories: Array<SohoSearchFieldCategoryType> = [];
      this.moduleFacades.forEach((module: LMModuleFacade) => updatedSearchCategories.push({
        name: module.title,
        checked: false
      }));
      this.searchCategories.set(updatedSearchCategories);
    }
  }

  dismissWelcomeMessage() {
    this.state.hideWelcome = true;
  }

  doTextSearch() {
    const selectedCategories: Array<string> = [];
    if (this.searchField && (this.searchField as any).searchfield && (this.searchField as any).searchfield.getSelectedCategories().length > 0) {
      // IDS currently only returns a jquery of the selected categories, and not a data version of the selected categories.
      // so need to extract the selected categories from their li query info
      const categories = (this.searchField as any).searchfield.getSelectedCategories();
      for (let i = 0; i < categories.length; i++) {
        const item: HTMLLIElement = categories[i];
        selectedCategories.push(item.innerText.trim());
      }
    }

    const searchEvent: LMFacadeSearchEvent = {
      type: 'onModuleSearch',
      value: this.searchValue(),
      categories: selectedCategories
    };
    this.search.emit(searchEvent );
  }

  clearTextSearch() {
    this.searchValue.set('');
    const searchEvent: LMFacadeSearchEvent = {
      type: 'onModuleSearch',
      value: '',
      categories: []
    };
    this.search.emit( searchEvent);
  }
}
